import isNil from "lodash/isNil";
import merge from "lodash/merge";
import reduce from "lodash/reduce";
import { getFullKey } from "PFCore/helpers/use_storage";

import { WorkflowState } from "../workflow_store_types";

// TODO: [SP-8824] Remove this migration 30 days after release to production
export const MIGRATION_KEY = "workflow-store-migrated";

const readLegacyValue = (storageKey: string) => window.storage.getItem(getFullKey(storageKey));

const normalizeColumns = (parsed: unknown): string[] => {
  if (!Array.isArray(parsed)) {
    return [];
  }
  return parsed.map((col: string | { name: string }) => (typeof col === "string" ? col : col.name));
};

const migrateField = (
  state: Partial<WorkflowState>,
  section: string,
  field: string,
  storageKey: string,
  transform?: (value: unknown) => unknown
): Partial<WorkflowState> => {
  const value = readLegacyValue(storageKey);
  if (isNil(value)) {
    return state;
  }

  return merge(state, { [section]: { [field]: transform ? transform(value) : value } });
};

export const migrateWorkflowStorage = (store: WorkflowState): WorkflowState => {
  const fields = [
    {
      section: "engagements",
      field: "pinnedIds",
      storageKey: "workflow_engagements_v2_pinned"
    },
    {
      section: "engagements",
      field: "groupBy",
      storageKey: "workflow_engagements_v2_group_by_group_by"
    },
    {
      section: "engagements",
      field: "columns",
      storageKey: "workflow_engagements_v2_columns",
      transform: normalizeColumns
    },
    {
      section: "roles",
      field: "pinnedIds",
      storageKey: "workflow_roles_v2_pinned"
    },
    {
      section: "roles",
      field: "groupBy",
      storageKey: "workflow_roles_v2_group_by_group_by"
    },
    {
      section: "roles",
      field: "columns",
      storageKey: "workflow_roles_v2_columns",
      transform: normalizeColumns
    }
  ];

  const newState = reduce(
    fields,
    (acc, field) => migrateField(acc, field.section, field.field, field.storageKey, field.transform),
    {} as Partial<WorkflowState>
  );

  const finalState = {
    ...store,
    engagements: { ...store.engagements, ...newState.engagements },
    roles: { ...store.roles, ...newState.roles }
  };

  window.localStorage.setItem(MIGRATION_KEY, "true");

  return finalState;
};
